import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=527a9c2a"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('527a9c2a')) {
      api.createRecord('527a9c2a', component.options)
    } else {
      api.reload('527a9c2a', component.options)
    }
    module.hot.accept("./EmptyLayout.vue?vue&type=template&id=527a9c2a", function () {
      api.rerender('527a9c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/EmptyLayout.vue"
export default component.exports